import React from 'react';
import { Calendar } from 'lucide-react';
export function EditorialHero() {
  return <div className="bg-white border-b border-[#E8E4DD]" data-id="element-65">
      <div className="editorial-container py-6 md:py-8" data-id="element-66">
        {/* Publisher Header */}
        <div className="bg-[#F5F3EE] border border-[#E8E4DD] rounded-lg px-4 py-3 md:px-6 md:py-4 mb-6 md:mb-8 shadow-sm" data-id="element-67">
          <div className="flex items-center justify-between" data-id="element-68">
            <div className="flex items-center gap-2" data-id="element-69">
              <span className="font-bold text-base md:text-xl text-[#1A2332]" data-id="element-70">
                HerMindBodySoul
              </span>
            </div>
            <span className="text-[10px] md:text-xs text-[#1A2332]/50 border border-[#E8E4DD] bg-white px-2 md:px-3 py-1 rounded-full whitespace-nowrap" data-id="element-71">
              ADVERTORIAL
            </span>
          </div>
        </div>

        {/* Main Headline */}
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-[#1A2332] leading-tight mb-4 md:mb-6" data-id="element-72">
          The Top 5 Supplements for Better Mood & Focus - And the One That
          Helped My Sister Bounce Back from Burnout
        </h1>

        {/* Subheadline */}
        <p className="text-base md:text-xl text-[#1A2332]/70 leading-relaxed mb-6 md:mb-8" data-id="element-73">
          Supplements are helping Christian women feel calmer, more focused, and
          emotionally steady again. But not all supplements are created equal.
          We compared the top brands so you don't waste money or time on the
          wrong one.
        </p>

        {/* Author Block */}
        <div className="flex items-center gap-3 md:gap-4 mb-6 md:mb-8 pb-6 md:pb-8 border-b border-[#E8E4DD]" data-id="element-74">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7DrrrPBqqbJuZs8QcBeSax/imgi_2_1754297733-download-3.png" alt="Rachel Thompson" className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover flex-shrink-0" data-id="element-75" />
          <div className="min-w-0" data-id="element-76">
            <p className="font-medium text-sm md:text-base text-[#1A2332]" data-id="element-77">
              Written by Hannah Thompson
            </p>
            <p className="font-light text-[11px] md:text-xs text-[#1A2332] mb-1" data-id="element-78">
              Christian Mom & Natural Wellness Researcher
            </p>
            <div className="flex items-center gap-1.5 md:gap-2 text-xs md:text-sm text-[#1A2332]/60" data-id="element-79">
              <Calendar className="w-3 h-3 md:w-4 md:h-4 flex-shrink-0" data-id="element-80" />
              <span data-id="element-81">January 15, 2025</span>
            </div>
          </div>
        </div>

        {/* Hero Image */}
        <img src="https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_kqp98xkqp98xkqp9.png?v=1765096861" alt="Natural ADHD supplements" className="w-full h-full object-cover " data-id="element-82" />

        {/* Social Proof Bar */}
        <div className="bg-[#FAF8F5] p-4 md:p-6 rounded-lg mb-6 md:mb-8" data-id="element-83">
          <p className="text-[10px] md:text-xs text-[#1A2332]/60 text-center mb-3" data-id="element-84">
            AS SEEN ON
          </p>
          <div className="flex items-center justify-center gap-4 md:gap-6 lg:gap-8 flex-wrap" data-id="element-85">
            {[{
            name: 'Forbes',
            src: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/e1797833-1b1c-4ecd-816a-8bc8fb99533e_7c453a58-dfea-4d20-86b6-dfa27a60de5c.png?v=1764528247'
          }, {
            name: 'WebMD',
            src: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/abc-broadcast-logo.png?v=1764527896'
          }, {
            name: 'Healthline',
            src: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/20da53f2-dd9c-4d44-b7c4-3797ef8820a2.png?v=1764528238'
          }, {
            name: 'Psychology Today',
            src: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/6e5a0dab-2330-4b32-a455-846f793a8c2d.png?v=1764528230'
          }, {
            name: 'Psychology Today',
            src: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/68f375b4-aede-4515-9342-7fc2aa76485b.png?v=1764527797'
          }].map((outlet, index) => <div key={`${outlet.name}-${index}`} className="w-16 h-6 md:w-20 md:h-7 lg:w-24 lg:h-8 flex items-center justify-center" data-id="element-86">
                <img src={outlet.src} alt={outlet.name} className="max-w-full max-h-full object-contain opacity-70" data-id="element-87" />
              </div>)}
          </div>
        </div>

        {/* Editorial Intro */}
        <div className="prose prose-sm md:prose-lg max-w-none" data-id="element-88">
          <div className="text-[#1A2332]/80 leading-relaxed space-y-3 md:space-y-4 text-sm md:text-base" data-id="element-89">
            <p data-id="element-90">
              <strong data-id="element-91">
                Dopamine and the brain's calm-regulate-focus circuit has
                recently been uncovered as one of the most important systems in
                women's mental and emotional health.
              </strong>
            </p>

            <p data-id="element-92">
              And it's not just about attention. This circuit controls your
              ability to stay calm under pressure, regulate emotions, follow
              through on tasks, and be mentally present with the people you
              love.
            </p>

            <p data-id="element-93">
              But when this circuit breaks down, everything feels like a
              struggle. Simple tasks feel overwhelming, you snap at your kids
              over small things, you can't stay focused long enough to finish
              reading a Bible passage, and the mental "noise" never stops.
            </p>

            <p data-id="element-94">
              But the solutions you're often offered, usually prescription
              medications loaded with side effects, leave you feeling
              disconnected, dulled, and even further from the person God
              intended you to be.
            </p>

            <p data-id="element-95">
              <strong data-id="element-96">
                That's why more Christian women than ever are looking for
                natural ways to support focus and emotional balance.
              </strong>
            </p>

            <p data-id="element-97">And one of the most effective solutions? </p>

            <p data-id="element-98">
              <strong data-id="element-99">
                The answer isn't in a pharmacy or a psychiatrist's office.
              </strong>{' '}
              It comes from botanicals used for thousands of years. Modern
              neuroscience has finally caught up: certain plant compounds
              directly support the brain's calm-regulate-focus pathways with
              proven efficacy and zero side effects. That's why thousands of
              Christian women are turning away from synthetic solutions and back
              to what God provided.
            </p>

            <p data-id="element-100">
              Stimulant medications can cause derealization. Even psychosis. The
              right botanical supplement? Can support your entire
              calm-regulate-focus circuit naturally without forcing your brain
              chemistry into overdrive.
            </p>

            <p data-id="element-101">
              But as more brands flood the market with "focus support" and "mood
              balance" supplements, which ones actually work? That's what we set
              out to discover.
            </p>

            <p data-id="element-102">
              Our team reviewed dozens of brands and narrowed them down to the
              five most talked-about options, and compared them on clinical
              dosing, full-cycle support, ingredient quality, and real results
              from women like you.
            </p>

            <p data-id="element-103">
              <strong data-id="element-104">Here's what we found...</strong>
            </p>
          </div>
        </div>
      </div>
    </div>;
}